import { useThemeColor } from 'components/src/hooks/useThemeColor';
import { useEffect } from 'react';
import styled, { useTheme } from 'styled-components';

const AuthLayoutStyled = styled.div<{ transparent?: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    max-height: 100vh;
    overflow-y: auto;
    width: calc(100% - 30px);
    max-width: 450px;
    border-radius: 20px;
    padding: ${({ transparent }) => (transparent ? 'none' : '30px')};
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({ theme, transparent }) =>
      transparent ? 'none' : theme.background};
    max-height: 90vh;

    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const AdminAuthLayout = ({
  children,
  transparent = false,
}: {
  children: React.ReactNode;
  transparent?: boolean;
}) => {
  // Read through ThemeProvider, not lightTheme, so an app that swaps the
  // primary (deliveries is navy) paints these screens in its own colour.
  const theme = useTheme();

  // These screens are primary-coloured to the edges, so the status bar is too.
  useThemeColor(theme.primary);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.document?.documentElement) {
      window.document.documentElement.style.backgroundColor = theme.primary;
    }
    return () => {
      if (typeof window !== 'undefined' && window.document?.documentElement) {
        window.document.documentElement.style.backgroundColor =
          theme.background;
      }
    };
  }, [theme]);
  return (
    <AuthLayoutStyled transparent={transparent}>
      <div>{children}</div>
    </AuthLayoutStyled>
  );
};
